import type { PopupData } from 'webapp-types';

import MetricEditComponent from 'webapp/components/metric/edit/index';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class MetricEditPopupComponent extends PopupInnerModalComponent<PopupData.Metric.Edit> {
	get model() {
		return this.popupData.model;
	}

	get isOpenedFromQueryOrScriptForm() {
		return this.popupData.isOpenedFromQueryOrScriptForm;
	}

	get isPeriodDataTypeHidden() {
		return !!this.popupData.isPeriodDataTypeHidden;
	}

	get isAllValuesDataTypeHidden() {
		return !!this.popupData.isAllValuesDataTypeHidden;
	}
	<template>
		<div class="title">
			<img src={{this.model.sourceAvatar}} alt={{this.model.sourceName}} />
			Metric definition
		</div>

		<MetricEditComponent
			@model={{this.model}}
			@onContentChange={{this.scheduleReposition}}
			@onClose={{this.close}}
			@isOpenedFromQueryOrScriptForm={{this.isOpenedFromQueryOrScriptForm}}
			@isPeriodDataTypeHidden={{this.isPeriodDataTypeHidden}}
			@isAllValuesDataTypeHidden={{this.isAllValuesDataTypeHidden}}
			@onSave={{this.popupData.onSave}}
			@afterSave={{this.popupData.afterSave}}
		/>
	</template>
}
